module.exports = __webpack_public_path__ + "media/images/help/wf-review-license-d21d01ef160f35ec0b17fa5e89eac4e5.png";